import { BaseCopyStamp } from "../../utils/BaseCopyStamp";
export class SopCopyStamp extends BaseCopyStamp {
  reset() {
    super.reset();
    this.setPoint(void 0);
  }
  setPoint(point) {
    const oldPoint = this._point;
    this._point = point;
    if (oldPoint != this._point) {
      this.setDirty();
      this.removeDirtyState();
    }
  }
  value(attrib_name) {
    if (this._point) {
      if (attrib_name) {
        return this._point.attribValue(attrib_name);
      } else {
        return this._point.index();
      }
    } else {
      return this._globalIndex;
    }
  }
}
